import { createElement, useCallback, PropsWithChildren, FC } from 'react'

export const StopPropagation: FC<PropsWithChildren<{ as?: string; className?: string }>> = ({ as, className, children }) => {
  const onClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
  }, [])

  return createElement(as || 'span', { onClick, className }, children)
}
